import { Optional, Pipe, PipeTransform } from '@angular/core';
import { ButtonNamesGA } from '@cpak/consts';
import { TrackingContextService, TrackingService } from '@cpak/main-features-lib/services';
import { getModalName } from '@cpak/shared/utils';
import { MenuItem } from 'primeng/api';
import { MenuItemsMappingGA } from '@cpak/consts';

@Pipe({ name: 'trackedMenuItems' })
export class TrackedMenuItemsPipe implements PipeTransform {
  private readonly modalName = getModalName();

  public constructor(@Optional() public trackingContext: TrackingContextService, public tracking: TrackingService) {}

  public transform(items: MenuItem[]): MenuItem[] {
    return this.trackMenuItems(items);
  }

  private trackFn(buttonName: typeof ButtonNamesGA[keyof typeof ButtonNamesGA]): void {
    this.tracking.trackClick({
      buttonName,
      modalName: this.modalName ?? undefined,
      modeName: this.trackingContext?.currentMode ?? undefined,
      tabName: this.trackingContext?.currentTab ?? undefined,
    });
  }

  private trackMenuItems(items: MenuItem[]): MenuItem[] {
    return items.map(item => {
      const buttonName = this.getMenuItemButtonName(item);

      if (!buttonName) {
        return item;
      }

      const trackedItem: MenuItem = {
        ...item,
        command: () => {
          this.trackFn(buttonName);

          item.command?.();
        },
      };

      if (item.items) {
        trackedItem.items = this.trackMenuItems(item.items);
      }

      return trackedItem;
    });
  }

  private getMenuItemButtonName(item: MenuItem): typeof ButtonNamesGA[keyof typeof ButtonNamesGA] | undefined {
    if (!item.id) {
      return undefined;
    }

    return MenuItemsMappingGA[item.id] as typeof ButtonNamesGA[keyof typeof ButtonNamesGA] | undefined;
  }
}
